import { Id } from "@dgs/core";
import { FC } from "react";
import { ApplicationForSidebarResource } from "../../shared/types/applicationForSidebar";
import { CarFleetTestDrivesLinks } from "../../shared/ui/CarFleetTestDrivesLinks";

interface Props {
	companyId: Id;
}

const getTestDriveLink = (companyId: Id, carFleet: ApplicationForSidebarResource) => {
	return `${carFleet.adminUrl}/companies/${companyId}/test-drives`;
};

export const CompanyTestDriveLinks: FC<Props> = ({ companyId }) => {
	return <CarFleetTestDrivesLinks linkTo={(carFleet) => getTestDriveLink(companyId, carFleet)} />;
};
